import React from 'react';
import { withAnalyticsAppContext } from '../../context/analytics-app-context';
import AnalyticsTable from '../analytics-table/AnalyticsTable';
import { isEmpty } from '../../utils/object-utils';
import './analytics-average-time-spent-data.scss';

function AnalyticsAverageTimeSpentData({ appContext }) {
    const { loading } = appContext;
    const { analyticsAverageTimeSpentData, totalAverageTimeForVisitors } = appContext.analyticsData || {};
    const analyticsPageProperties = [
        { property: 'shortUrlFormat', headerText: 'Page URL', isProgressBar: false },
        { property: 'formattedAverageTimeForVisitors', headerText: 'Average Time Spent', isProgressBar: false },
        { property: 'averageTimePercentage', headerText: `Time Spent out of ${totalAverageTimeForVisitors}`, isProgressBar: true }
    ];
    return (
        <div className='analytics-grid-item-root analytics-average-time-spent-data-root analytics-component grid-item'>
            <div className='analytics-grid-item-data analytics-average-time-spent-data grid-item'>
                <div className='card-header-root'>
                    <div className='card-header-content'>
                        <span className='card-header-title'>
                            <h6> {'Average Time Spent'}</h6>
                        </span>
                    </div>
                </div>
            </div>
            <div className='card-body'>
                {loading && 'Loading...'}
                {loading || isEmpty(analyticsAverageTimeSpentData) ?
                    null :
                    <AnalyticsTable tableProperties={analyticsPageProperties} tableData={analyticsAverageTimeSpentData}></AnalyticsTable>}
            </div>
        </div>
    );
}

export default withAnalyticsAppContext(AnalyticsAverageTimeSpentData);
